import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { get } from 'lodash';
import { ICsvData, IInvalidData } from './index';

interface IColumn {
  title: string;
  dataIndex: string;
  key: string;
}
interface IProps {
  columns: IColumn[];
  data: ICsvData[] | IInvalidData[];
}

export default function CsvTable(props: IProps) {
  const { columns, data } = props;
  return (
    <TableContainer component={Paper} sx={{ overflowY: 'scroll', height: '300px' }}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {columns.map((c, index) => (
              <TableCell key={index}>{c.title}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              {columns.map((c) => (
                <TableCell key={c.key}>{get(row, c.dataIndex)}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
